import React from "react";
import PropTypes from "prop-types";
import PrimaryHero from "wonderbly-components/lib/PrimaryHero";
import { localiseUrlII } from "src/common/utils/format-localised-url";
import { useCountry } from "src/client/js/view/hooks";

import "./MainHero.scss";

const MainHero = (props) => {
  const country = useCountry();

  return (
    <PrimaryHero
      containerClass="container-guttered"
      title={props.title}
      body={props.bodyText}
      ctaLabel={props.ctaLabel}
      ctaLink={
        props.ctaLink.href ? localiseUrlII(country, props.ctaLink.href) : null
      }
      backgroundColour={props.backgroundColour}
      images={props.items}
      reverseOrientation={props.reverseOrientation}
      autoPlay={props.carouselAutoplay}
    />
  );
};

MainHero.propTypes = {
  title: PropTypes.string,
  bodyText: PropTypes.string,
  backgroundColour: PropTypes.string,
  items: PropTypes.array,
  ctaLabel: PropTypes.string,
  ctaLink: PropTypes.object,
  reverseOrientation: PropTypes.bool,
  carouselAutoplay: PropTypes.bool,
};

export default MainHero;
